<template>
  <!-- 头部 title logo -->
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <!-- <img :src="logo" alt=""> -->
    <transition name="sidebarLogoFade">
      <router-link
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link"
        to="/"
      >
        <img :src="logo" alt="">
        <el-avatar
          class="sidebar-logo"
          icon="el-icon-user-solid"
          :size="40"
          :src="this.$store.getters.protoImg || logo"
        >
          <img :src="logo">
        </el-avatar>
        <!-- <h1 class="sidebar-title">{{ $store.getters.form ? $store.getters.form.TITLE_NAME:'励拓新安智能消防' }} </h1> -->
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <el-avatar
          class="sidebar-logo"
          icon="el-icon-user-solid"
          :size="40"
          :src="this.$store.getters.protoImg || logo"
        >
          <img :src="logo">
        </el-avatar>
        <h1 class="sidebar-title">
          {{ $store.getters.form.TITLE_NAME || "励拓新安智能消防" }}
        </h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
// const Base64 = require('js-base64').Base6
// import { mapActions } from 'vuex'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      circleUrl: { img: '@/assets/Images/logo.png' }, // 用户头像
      logo: require('@/assets/Images/logo.png')
    }
  },
  created() {
    this.$store.dispatch('logoTitle/userInfo')
    setTimeout(() => {
      if (this.$store.getters.form.TITLE_NAME) {
        this.$store.dispatch('logoTitle/userImage')
      }
    }, 500)

    // 获取图片信息
  },
  mounted() {
    this.circleUrl.img = sessionStorage.getItem('protoImg')
  },
  methods: {
    // 获取

    downloadFile(fileName, data) {
      if (!data) {
        return
      }
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}
.sidebar-logo-container img {
  width: 9%;
  height: 9%;
}
.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
      background-color: #fff;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
